import { FallBackImage } from "../default/fallback-image";
import ReactPaginate from 'react-paginate';
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { fetchGetAdsFilters } from "../../../services/api";
import { NumericFormat } from 'react-number-format';

export default function StockInventoryListing({
    ads,
    pageSize
}) {
    const router = useRouter();
    const pageCount = Math.ceil(ads.paginationOut.totalRows / pageSize);
    const from = !router.query.pag ? 1 : (parseInt(router.query.pag) * parseInt(pageSize)) + 1;
    const to = !router.query.pag ? ads.items.length : (parseInt(router.query.pag) * parseInt(pageSize)) + ads.items.length;
    const [filters, setFilters] = useState({ isLoading: true, brands: [], models: [], yearsModel: [], transmissions: [], fuels: [] });

    const handlePageClick = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.pag = event.selected;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    };
    const handleFilterCheckboxClick = (event, value, type) => {
        if (event.target.checked) {
            if (router.query[type]) router.query[type] = router.query[type] + `|${value}`;
            else router.query[type] = value;
        }
        else {
            if (router.query[type].indexOf('|') >= 0) {
                const splitStr = router.query[type].split('|');
                router.query[type] = splitStr.filter(item => item !== value).join('|');
            }
            else delete router.query[type];
        }
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleOrderChange = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.ordem = event.target.value;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleGridTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'grid';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleListTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'list';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceFromChange = (event) => {
        if (event.target.value) router.query.preco_de = event.target.value;
        else delete router.query['preco_de'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceToChange = (event) => {
        if (event.target.value) router.query.preco_ate = event.target.value;
        else delete router.query['preco_ate'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }

    useEffect(() => {
        if (filters.isLoading) {
            fetchGetAdsFilters({
                condition: router.pathname === '/novos'
                    ? 'NEW'
                    : router.pathname === '/seminovos'
                        ? 'USED'
                        : ''
            })
                .then(res => {
                    if (res) { setFilters({ isLoading: false, ...res }); }
                })
                .catch(() => { setFilters({ ...filters, isLoading: false }); });
        }
        else if (!filters.isLoading) $(".at_scrollbar").mCustomScrollbar({ axis: "y" });
    }, [filters]);

    useEffect(() => {
        $(".ring-preloader").fadeOut();
    }, [ads]);

    return (
        <section className="inventory-details-area ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-3">
                        <div className="iv2_sidebar bg-white rounded overflow-hidden">
                            {
                                filters.brands.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_1" className="accordion-button bg-transparent text-secondary p-0 pe-1" data-bs-toggle="collapse">Marca</a>
                                                </h6>
                                                <div className="collapse show" id="acc_1">
                                                    <div className="accordion-body ps-0 pb-0 pe-2">
                                                        <ul className="iv2_sidebar_list at_scrollbar">
                                                            {
                                                                filters.brands.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.marca ? router.query.marca.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'marca'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.models.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_2" className="accordion-button bg-transparent text-secondary p-0 pe-1" data-bs-toggle="collapse">Modelo</a>
                                                </h6>
                                                <div className="collapse show" id="acc_2">
                                                    <div className="accordion-body ps-0 pb-0 pe-2">
                                                        <ul className="iv2_sidebar_list at_scrollbar">
                                                            {
                                                                filters.models.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.modelo ? router.query.modelo.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'modelo'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.yearsModel.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_3" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Ano Modelo</a>
                                                </h6>
                                                <div className="collapse" id="acc_3">
                                                    <div className="accordion-body ps-0 pb-0 pe-2">
                                                        <ul className="iv2_sidebar_list at_scrollbar">
                                                            {
                                                                filters.yearsModel.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input type="checkbox"
                                                                                defaultChecked={router.query.ano ? router.query.ano.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'ano'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.transmissions.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_4" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Câmbio</a>
                                                </h6>
                                                <div className="collapse" id="acc_4">
                                                    <div className="accordion-body ps-0 pb-0 pe-2">
                                                        <ul className="iv2_sidebar_list at_scrollbar">
                                                            {
                                                                filters.transmissions.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.cambio ? router.query.cambio.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'cambio'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.fuels.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_5" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Combustível</a>
                                                </h6>
                                                <div className="collapse" id="acc_5">
                                                    <div className="accordion-body ps-0 pb-0 pe-2">
                                                        <ul className="iv2_sidebar_list at_scrollbar">
                                                            {
                                                                filters.fuels.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.combustivel ? router.query.combustivel.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'combustivel'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="iv2_sidebar_widget iv2_rangeslider_widget">
                                <div className="accordion iv2_sidebar_accordion">
                                    <div className="accordion-item border-0">
                                        <h6 className="accordion-header ">
                                            <a href="#acc_6" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Preço</a>
                                        </h6>
                                        <div className="collapse" id="acc_6">
                                            <div className="accordion-body ps-0 pb-0">
                                                <select
                                                    className="form-select fw-500"
                                                    onChange={handlePriceFromChange}>
                                                    <option value=''>Preço De:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </div>
                                            <div className="accordion-body ps-0 pb-0">
                                                <select
                                                    className="form-select fw-500"
                                                    onChange={handlePriceToChange}>
                                                    <option value=''>Preço Até:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9">
                        <div className="iv_listing mt-5 mt-xl-0">
                            <div className="iv_listing_top d-flex flex-wrap align-items-center bg-white justify-content-center justify-content-sm-between rounded mb-4">
                                <p className="mb-0 fw-500 d-inline-block">{`Mostrando de ${from} até ${to} de ${ads.paginationOut.totalRows} registros`}</p>
                                <div className="iv_listing_filter_menu d-flex flex-wrap align-items-center justify-content-center">
                                    <p className="mb-0 flex-shrink-0 fw-semibold">Ordenar Por:</p>
                                    <select
                                        className="form-select fw-500"
                                        onChange={handleOrderChange}>
                                        <option value='BRAND_AND_MODEL'>Marca e Modelo</option>
                                        <option value='LOWEST_PRICE'>Menor Preço</option>
                                        <option value='BIGGEST_PRICE'>Maior Preço</option>
                                        <option value='NEWER_VEHICLES'>Mais Novos</option>
                                    </select>
                                    <a href="#" className={`grid_btn ${!router.query.tipo_lista || router.query.tipo_lista === 'grid' ? 'active' : ''}`} onClick={handleGridTypeClick}><i className="flaticon-menu-1"></i></a>
                                    <a href="#" className={`grid_btn ${router.query.tipo_lista && router.query.tipo_lista === 'list' ? 'active' : ''}`} onClick={handleListTypeClick}><i className="flaticon-list-interface-symbol"></i></a>
                                </div>
                            </div>
                            <div className="row g-4 justify-content-center">
                                {
                                    ads.items.length > 0
                                        ? ads.items.map((item, index) =>
                                            !router.query.tipo_lista || router.query.tipo_lista === 'grid'
                                                ? <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6" key={index}>
                                                    <div className="filter-card-item position-relative overflow-hidden rounded bg-white">
                                                        <div className="feature-thumb position-relative overflow-hidden">
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <FallBackImage
                                                                    className='img-card-fluid'
                                                                    height={600}
                                                                    width={800}
                                                                    alt='carro'
                                                                    src={item.photos.length > 0 ? item.photos[0] : "../../../img/home1/car-1.jpg"} />
                                                            </a>
                                                        </div>
                                                        <div className="filter-card-content">
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`} className="mt-2 d-block">
                                                                <h5
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>{`${item.brand} ${item.model}`}</h5>
                                                            </a>
                                                            <span
                                                                className="meta-content"
                                                                style={{
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    display: 'inline-block',
                                                                    width: '100%'
                                                                }}>{item.version}</span>
                                                            <hr className="spacer mt-3 mb-3" />
                                                            <div className="card-feature-box d-flex align-items-center mb-4">
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.transmission}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                    {item.transmission}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.fuel}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                    {item.fuel}
                                                                </div>
                                                            </div>
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`} className="btn outline-btn btn-sm d-block">Simular Financiamento</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-12" key={index}>
                                                    <div className="listing_card_item bg-white rounded p-3 d-lg-flex align-items-center position-relative">
                                                        <div className="thumb-wrapper overflow-hidden rounded flex-shrink-0">
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <FallBackImage
                                                                    className='img-list-fluid'
                                                                    height={600}
                                                                    width={800}
                                                                    alt='carro'
                                                                    src={item.photos.length > 0 ? item.photos[0] : "img/home1/car-1.jpg"} />
                                                            </a>
                                                        </div>
                                                        <div className="listing_card_content ms-lg-4 mt-4 mt-lg-0">
                                                            <span className="small-btn-meta">
                                                                {
                                                                    item.price && item.price > 0
                                                                        ? <NumericFormat
                                                                            value={item.price ?? 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator="."
                                                                            decimalSeparator=","
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix='R$ ' />
                                                                            : <span className="small-btn-meta">Consulte-nos</span> 
                                                                        }
                                                            </span>
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <h5 className="mb-1">{`${item.brand} ${item.model}`}</h5>
                                                            </a>
                                                            <span className="meta-text" style={{ fontSize: '14px' }}><strong className="fw-semibold">{item.version}</strong></span>
                                                            <p className="mt-2 mb-3 pera-text-2" title={item.optionals.join(' - ')}>
                                                                {
                                                                    item.optionals.length >= 1
                                                                        ? item.optionals.join(' - ').length > 255
                                                                            ? `${item.optionals.join(' - ').substring(0, 255)} ...`
                                                                            : item.optionals.join(' - ').substring(0, 255)
                                                                        : 'nenhum opcional cadastrado'
                                                                }
                                                            </p>
                                                            <div className="card-feature-box d-flex flex-wrap align-items-center">
                                                                <div
                                                                    className="icon-box d-flex align-items-center border"
                                                                    title={item.transmission}>
                                                                    <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                    {item.transmission}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center border"
                                                                    title={item.fuel}>
                                                                    <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                    {item.fuel}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        )
                                        : <div style={{ textAlign: 'center' }}>
                                            <p>nenhum registro encontrado...</p>
                                        </div>
                                }
                            </div>
                            <div className="template-pagination mt-5 pg-style-2">
                                <ReactPaginate
                                    forcePage={router.query.pag ? parseInt(router.query.pag) : 0}
                                    className="d-flex align-items-center justify-content-center"
                                    activeLinkClassName="active"
                                    breakLabel="..."
                                    nextLabel={<i className="fa-solid fa-angles-right"></i>}
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    previousLabel={<i className="fa-solid fa-angles-left"></i>}
                                    renderOnZeroPageCount={null} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}